<template>
  <section class="">
    <Login />
  </section>
</template>

<script>
import Login from "./SocialLogin.vue";

export default {
  name: "LoginPage",
  components: {
    Login,
  },
  mounted() {},
};
</script>
